<template>
<!--    做自己节分享海报 -->
  <div v-if="bodyShow && poster" class="poster-main">
      <img v-if="poster" class="poster-img" :src="poster" alt="">
      <p class="small">长按保存海报至本地，分享好友</p>
      <!-- btn -->
      <div class="btn">
        <img @click="resetCeping()" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/reset-ceping81.png" alt="">
        <img @click="toRank()" src="https://themes-cdn.xjy.cn/statics/zuoziji/images/2020/be-myself/go-be-myself.png" alt="">
      </div>
  </div>
</template>

<script>
import { queryString, getStorage, setStorage, deleteStorage,isMain} from '@/utils/tools'
import { getData,saveData,ceping81_poster,ceping81_info,ceping81_reset,ceping81_event } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            cid:81,
            bodyShow:false,
            qustion:{},
            userInfo:{},
            poster:'',
            type_obj:{},
             // 上一页面路由
            formPath: '',
        }
    },
    methods:{
        // 跳转海报
        toRank(){
            // 查看排行榜统计
            ceping81_event({
                cid:81,
                event:'LookRank'  
            }).then((data_)=>{
                this.$router.push('/ceping81_rank');
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 重置测评
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-12-07 12:04:43
        */
        resetCeping(){
            this.$dialog.confirm({
                title: '确认提示',
                message: '是否确认重新测评？',
            }).then(() => {
                saveData({
                    cid:this.cid,
                    data:''
                }).then(()=>{
                    deleteStorage('/ceping81');
                    ceping81_reset();
                    if (this.formPath === '/ceping81') {
                        this.$router.back();
                    } else {
                        this.$router.push('/ceping81');
                    }
                });
            }).catch(() => {
                // on cancel
            });
        },
        // 获取答题信息
        getDataHandle(){
            //调用加载中
            this.$emit('loadingHandle',true,"2024，回来做自己(σ≧∀≦σ)");
            Promise.all([getData({cid:this.cid}),ceping81_info()]).then((res)=>{
                let data = res[0];
                document.title = '2024，回来做自己(σ≧∀≦σ)';
                if(!data.data){
                    if (this.formPath === '/ceping81') {
                        this.$router.back();
                    } else {
                        this.$router.push('/ceping81');
                    }
                    return
                }
                //关闭加载中
                this.$emit('loadingHandle',false);

                let seatStorage =  getStorage(this.$route.path,'question');
                this.qustion = data.data?JSON.parse(data.data):{};
                this.userInfo = res[1];
                this.type_obj = {
                    uid:res[1].uid
                };
                shareCon("ceping81", this,this.type_obj);
                this.pullData();
                this.bodyShow = true;
            });

        },
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"2024，回来做自己(σ≧∀≦σ)");
            let num = 0;
            let one = this.qustion.one,
            two = this.qustion.two,
            three = this.qustion.three,
            four = this.qustion.four,
            five = this.qustion.five;
            if(one && two && three && four && five){
                // 计算海报生成规则
                if(one=='A' && two =='A' && five=='B'){
                    num = 1;
                }else if(one=='B' && two =='B'  && five=='A'){
                    num = 2;
                }else if(one=='B' && two =='B'  && five=='B'){
                    num = 3;
                }else if(one=='B' && two =='A'  && five=='A'){
                    num = 4;
                }else if(one=='B' && two =='A'  && five=='B'){
                    num = 5;
                }else if(one=='A' && two =='A'  && five=='A'){
                    num = 6;
                }else if(one=='A' && two =='B'  && five=='A'){
                    num = 7;
                }else if(one=='A' && two =='B'  && five=='B'){
                    num = 9;
                }else if(one=='B'   && five=='C'){
                    num = 8;
                }else if(one=='A'   && five=='C'){
                    num = 10;
                }
                if(!num || !this.userInfo.uid){
                    this.$toast('用户信息获取失败请重试！');
                    return
                }   
                ceping81_poster({
                    link:`https://open.xjy.cn/${isMain()?'main':'test'}/ceping81?uid=${this.userInfo.uid}`,
                    extra:num
                }).then((data)=>{
                    document.title = '2024，回来做自己(σ≧∀≦σ)';
                    this.poster = data.poster;
                    //关闭加载中
                    this.$emit('loadingHandle',false);
                });
            }else{
                if (this.formPath === '/ceping81') {
                    this.$router.back();
                } else {
                    this.$router.push('/ceping81');
                }
            }
        }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created(){
        this.getDataHandle();
        
    }
}
</script>
<style lang="scss">
body{
    background-color: #ffffff  !important;
}
</style>
<style lang="scss" scoped>
.poster-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 0px 109px;
    // background-color: #FFF4EE;
    .poster-img{
        width: 100%;
        // height: 1130px;
        margin-bottom: -20px;
    }
    .small{
        background-color: #ffffff;
        padding-top: 5px;
        font-size: 20px;
        font-weight: 300;
        color: #B50707;
        margin-bottom: 15px;
        text-align: center;
        width: 100%;
    }
    .btn{
        position: fixed;
        left:50%;
        transform: translateX(-50%);
        bottom:0px;
        width: 100%;
        padding: 0 24px 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // background-color: #FFF4EE;
        img{
            width: 302px;
        }
    }
}
</style>